import React, { useCallback, useState, useEffect } from 'react'
import { InputSwitch } from 'primereact/inputswitch'
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import BusinessActions from '../../Redux/actions/business-actions';
import CustomToast from '../../Components/CustomToast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { SignupRequirementsPreference } from './SignupRequirementsPreference';
import { DuplicatePhonePreference } from './DuplicatePhonePreference';


export const Preference = () => {
    const { t } = useTranslation("common");

    const { errorUpdatingPspBill, updatedPspBill, updatingPspBill, business } = useSelector((state) => state.businesses);

    const [checked, setChecked] = useState(business?.feesPassedOn);
    const [checkedClicked, setCheckedClicked] = useState(false);
    const [toastData, setToastData] = useState({
        summary: '', severity: '', detail: '', life: 0
    });
    const [toastTrigger, setToastTrigger] = useState(false);
    const [confirm, setConfirm] = useState(false);


    //redux states
    const id = business?.id
    //redux calls
    const dispatch = useDispatch();
    const updatePspBill = useCallback((businessId) => dispatch(BusinessActions.updatePspBillRequest(businessId)), [dispatch]);
    const getBusiness = useCallback((id) => dispatch(BusinessActions.businessRequest(id)), [dispatch]);

    const showToast = (summary, severity, detail) => {
        setToastData({
            summary,
            severity,
            detail,
            life: 3000,
        });
        setToastTrigger(true)
    }

    useEffect(() => {
        if (!updatingPspBill && updatedPspBill && checked && checkedClicked) {
            showToast(t("success"), "success", t("preference_toast_sub"))
        }
        if (!updatingPspBill && updatedPspBill && !checked && checkedClicked) {
            showToast(t("success"), "success", t("preference_toast_business"))
        }
        if (!updatingPspBill && errorUpdatingPspBill && checkedClicked) {
            showToast(t("Failure"), "error", t("preference_toast_error"))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatingPspBill, updatedPspBill, errorUpdatingPspBill, checked, business, checkedClicked])


    const handleSwitch = (e) => {
        setConfirm(true)
        const value = e?.value;
        setChecked(value);
    }

    const confirmFooterBody = () => {
        const proceedClick = () => {
            setCheckedClicked(true);
            updatePspBill(id)
        }

        const cancelClick = () => {
            setConfirm(false)
            setChecked(business?.feesPassedOn)
        }

        return <div className='flex justify-content-end'>
            <Button label={t('common.no')}
                icon="pi pi-times"
                className="p-button-text"
                id="pause_no_btn"
                onClick={() => cancelClick()}
            ></Button>
            <Button label={t('common.ok')} loading={updatingPspBill}
                icon="pi pi-check" id="pause_yes_btn" disabled={checkedClicked}
                onClick={() => proceedClick()}></Button>
        </div>
    }

    return (
        <div className='card p-card'>
            <CustomToast
                {...toastData}
                trigger={toastTrigger}
                handleActionsAfterToast={() => {
                    setToastTrigger(false);
                    setCheckedClicked(false)
                    setConfirm(false);
                    getBusiness(id);
                }}
                handleActionsAfterErrorToast={() => {
                    setCheckedClicked(false)
                    setToastTrigger(false)
                }}
            />

            <ConfirmDialog
                visible={confirm}
                onHide={() => setConfirm(false)}
                header={checked ? t("api_settings.enablePassingFeesOnHeader")
                    : t("api_settings.disablePassingFeesOnHeader")}
                footer={confirmFooterBody()}
                style={{ width: "350px" }}
                message={checked ? t("api_settings.billSubscriberConfirmation")
                    : <Trans i18nKey="api_settings.billMerchantConfirmation" values={{ business: business?.name }} components={{ 1: <span className='font-bold' /> }} />
                }
            />


            <div className="grid">
                <section className="col-3">
                    <p className='font-bold text_line'>{t("api_settings.bill_subscribers")}</p>
                </section>

                <section className="col-6">
                    <p className='text_line'>{t("api_settings.enable_fees")}</p>
                </section>

                <section className="col-3 flex justify-content-end gap-2">
                    <InputSwitch
                        checked={checked}
                        onChange={(e) => handleSwitch(e)}
                    />
                    <p className='font-bold text_line'>{checked ? t("api_settings.on") : t("api_settings.off")}</p>
                </section>
            </div>

            <SignupRequirementsPreference />
            <DuplicatePhonePreference />
        </div>
    )
}
